import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    captureType: null,
    designerId: null,
    designerName: null,
    next: null,
    open: false,
    productId: null,
    searchGender: null,
    searchTerm: null,
};

const emailCaptureOverlay = createSlice({
    name: "emailCaptureOverlay",
    initialState,
    reducers: {
        openCustomerCaptureOverlay(state, action) {
            state.captureType = action.payload.captureType;
            state.designerId = action.payload.designerId;
            state.designerName = action.payload.designerName;
            state.next = action.payload.next;
            state.open = true;
            state.productId = action.payload.productId;
            state.searchGender = action.payload.searchGender;
            state.searchTerm = action.payload.searchTerm;
        },
        closeCustomerCaptureOverlay(state) {
            state.captureType = null;
            state.designerId = null;
            state.designerName = null;
            state.next = null;
            state.open = false;
            state.productId = null;
            state.searchGender = null;
            state.searchTerm = null;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = emailCaptureOverlay;
// Extract and export each action creator by name
export const { openCustomerCaptureOverlay, closeCustomerCaptureOverlay } = actions;
// Export the reducer, either as a default or named export
export default reducer;
